import {
  SET_LOADING_RENOV_DOC,
  SET_DOCUMENTOS_RENOV_DOC,
  SET_TIPOS_DOCUMENTOS_RENOV_DOC,
  SET_TIPO_PESSOA,
  SET_TIPOS_DOC_OBRIGATORIOS_OPCIONAIS
} from './types';

const initialState = {
  loadingPage: false,
  idTipoPessoa: null,
  documentosSolicitados: null,
  docsObrigatorios: [],
  docsOpcionais: [],
  tiposDocumentoSolicitados: null,
  tiposDocObrigatoriosOpcionais: []
}

export default function renovacaoDocumentosReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TIPOS_DOCUMENTOS_RENOV_DOC:
      return {
        ...state,
        tiposDocumentoSolicitados: action.payload
      }
    case SET_DOCUMENTOS_RENOV_DOC:
      return {
        ...state,
        documentosSolicitados: action.payload,
        docsObrigatorios: action.payload.filter(x => x.Obrigatorio),
        docsOpcionais: action.payload.filter(x => !x.Obrigatorio),
      }
    case SET_TIPO_PESSOA:
      return {
        ...state,
        idTipoPessoa: action.payload
      }
    case SET_LOADING_RENOV_DOC:
      return {
        ...state,
        loadingPage: action.payload
      }
    case SET_TIPOS_DOC_OBRIGATORIOS_OPCIONAIS:
      return {
        ...state,
        tiposDocObrigatoriosOpcionais: action.payload
      }
    default:
      return state
  }
}